import firebaseApp from '../../utils/firebase'
import axios from 'axios/dist/axios'
import { w } from '../../utils/helpers'
import Raven from 'raven-js'

export default {
  markAsRead({
    getters
  }, msgKey) {

    const sid = getters.bindSID
    const uid = getters.bindUID

    if (!sid)
      return null

    firebaseApp.ref.child('messages')
      .child(sid)
      .child('data')
      .child(msgKey)
      .child('read')
      .child(uid)
      .set(firebaseApp.TIMESTAMP)

  },
  markAsDelivered({
    getters
  }, msgKey) {

    const sid = getters.bindSID
    const uid = getters.bindUID

    if (!sid)
      return null

    firebaseApp.ref.child('messages')
      .child(sid)
      .child('data')
      .child(msgKey)
      .child('delivered')
      .child(uid)
      .set(firebaseApp.TIMESTAMP)

  },
  incrementMsgCount({ getters }) {

    if (getters.bindSID)
      firebaseApp.ref.child('messages')
        .child(getters.bindSID)
        .child('visitor_msg_count')
        .transaction((c)=>{
          return c + 1
        })

  },
  postData({
    getters,
    dispatch
  }, data) {

    const sid = getters.bindSID
    const uid = getters.bindUID

    if (!sid)
      return null

    //check queued state and update if needed
    if (getters.getViewState == 1)
      dispatch('setQueuedState')

    //do integration actions here
    dispatch('updateLobby')

    return firebaseApp.ref.child('messages')
      .child(sid)
      .child('data')
      .push({
        from: uid,
        created_at: firebaseApp.TIMESTAMP,
        ...data
      })
      .key

  },
  postMessage({
    getters,
    dispatch
  }, message) {
    if (getters.getState == 4)
      dispatch('setReopenedState')

    //do data sanitation/validation here

    let data = {
      type: 0,
      message
    }

    // evaluate queued_at before postData
    const isNew = typeof getters.getSession.queued_at === 'undefined';

    return dispatch('postData', data).then(msgKey => {
      if (!isNew) dispatch('postNotify', {})
      dispatch('incrementMsgCount')
      dispatch('postIntegration',{
        msgKey,
        isNew
      })

      return msgKey

    })


  },
  postEvent({
    getters,
    dispatch
  }, { type, info }) {

    //do data sanitation/validation here
    const types = {
      'left': 0,
      'joined': 1,
      'disconnected': 2,
      'rated': 7,
      'comment': 8,
      'ended': 9,
      'advanceRated': 11
    }

    let data = {
      type: 1,
      subtype: types[type],
      ...info || {}
    }

    return dispatch('postData', data)

  },
  postFile({
    getters,
    dispatch,
    commit
  }, ref) {

    let data = {
      type: 2,
      count: 0,
      meta: {}
    }

    let files = ref
    const unSafeFiles = [
      'dmg', 'pkg', 'sh', //linux/mac
      'exe', 'bat', 'com', 'cmd', 'jar', //windows executables
      'msp', 'application', 'msi', //installers
      'scr', 'hta', 'cpl', 'msc', //system files
      'vb', 'vbs', 'js', 'jse', //external scripts
      'ws', 'wsf', 'wsc', 'reg', //internal scripts
      'ps1', 'ps1xml', 'ps2', 'ps2xml', 'msh1xml', 'msh2xml', //others
    ]

    for (let i = 0; i < (files.length <= 3 ? files.length : 3); i++) {

      let file = files[i]
      let ext = file.name.split('.').pop().toLowerCase()

      let error_message = file.size > 10000000 ?
        getters.getLang.maxFileError : unSafeFiles.indexOf(ext) >= 0 ?
        getters.getLang.disallowedFile : ''

      if (error_message) {
        let k = getters.getFiles.length
        commit('pushFile', {
          name: file.name,
          size: file.size,
          upload: 0,
          cancelled: false,
          error: error_message,
          cancel() {
            commit('updateFile', {
              k,
              f: 'cancelled',
              v: true
            })
          }
        })
        continue
      }

      data.count += 1
      data.meta[i] = {
        name: file.name,
        size: file.size,
        upload: 0,
        format: ext.length < 5 ? ext : '',
        format_type: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'].indexOf(ext) > -1 ? 'image' : ext
      }

    }

    if (data.count)
      dispatch('postData', data).then(k => {
        for (let i in data.meta)
          dispatch('doUpload', {
            k,
            i,
            meta: data.meta[i],
            file: files[i]
          })
      })

  },
  doUpload({
    getters,
    commit,
    dispatch
  }, {
    k,
    i,
    meta,
    file
  }) {

    let CancelToken = axios.CancelToken
    let abort = CancelToken.source()

    const key = getters.getFiles.length
    const sid = getters.bindSID

    commit('pushFile', {
      cancel: abort.cancel,
      cancelled: false,
      error: false,
      ...meta
    })

    let ref = firebaseApp.ref
      .child('messages')
      .child(sid)
      .child('data')
      .child(k)
      .child('meta')
      .child(i)

    let fd = new FormData()

    ref.child('abort')
      .onDisconnect()
      .set(true)

    fd.append('UPLOADCARE_PUB_KEY', '@@UPLOADCARE_PUB_KEY')
    fd.append('UPLOADCARE_STORE', '@@UPLOADCARE_STORE')
    fd.append('file', file)

    axios.post('@@UPLOADCARE_URL', fd, {
        cancelToken: abort.token,
        onUploadProgress(progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          commit('updateFile', {
            k: key,
            f: 'upload',
            v: percentCompleted
          })
          ref.child('upload').set(percentCompleted)
        }
      })
      .then(({
        data
      }) => {

        //success

        ref.child('abort')
          .onDisconnect()
          .cancel()

        ref.child('url')
          .set("//www.ucarecdn.com/" + data.file + "/")

        dispatch('postIntegration', {
          msgKey: k,
          i
        })


      })
      .catch((thrown) => {
        if (axios.isCancel(thrown)) {
          commit('updateFile', {
            k: key,
            f: 'cancelled',
            v: true
          })
          ref.child('abort').set(true)
        }
      })

  },
  postPageEvent({ getters, dispatch }) {

    const sid = getters.bindSID
    const uid = getters.bindUID
    const reload = window.performance && window.performance.navigation && window.performance.navigation.type
    const url = location.href

    if (url.indexOf(w.app('popout'))>=0 || !sid)
      return

    let lastEvent = getters.getLastPageEvent
    let pageEventKey = getters.getPageEventKey
    let pageEventSubKey = getters.getPageEventSubKey

    if (reload &&
      !pageEventKey &&
      lastEvent &&
      lastEvent.url == url
    )
      dispatch('updatePageEvent',lastEvent.msgKey)
    else {

      if (pageEventKey)
        dispatch('disconnectPageEvent')

      let key = firebaseApp.ref.child('messages')
        .child(sid)
        .child('data')
        .push({
          from: uid,
          created_at: firebaseApp.TIMESTAMP,
          type: 1,
          subtype: 2,
          title: document.title,
          url
        })
        .key

      dispatch('updatePageEvent',key)

    }

  },
  updatePageEvent({ getters, commit }, key) {

    const sid = getters.bindSID

    let eventRef = firebaseApp.ref
      .child('messages')
      .child(sid)
      .child('data')
      .child(key)

    let pkey = eventRef.child('data').push({
      created_at: firebaseApp.TIMESTAMP
    }).key

    commit('setPageEventSid',sid)
    commit('setPageEventKey',key)
    commit('setPageEventSubKey', pkey)

    eventRef
      .child('left_at')
      .set('')

    eventRef
      .child('left_at')
      .onDisconnect()
      .set(firebaseApp.TIMESTAMP)

    eventRef
      .child('data')
      .child(pkey)
      .child('left_at')
      .onDisconnect()
      .set(firebaseApp.TIMESTAMP)

    //console.log('postPageEvent processed.')


  },
  disconnectPageEvent({ getters, commit }) {

    let pageEventSid = getters.getPageEventSid
    let pageEventKey = getters.getPageEventKey
    let pageEventSubKey = getters.getPageEventSubKey

    if (!pageEventSid || !pageEventKey || !pageEventSubKey)
      return null

    let eventRef = firebaseApp.ref
      .child('messages')
      .child(pageEventSid)
      .child('data')
      .child(pageEventKey)

      //console.log(pageEventKey, pageEventSubKey, eventRef.toString())

      eventRef
        .child('left_at')
        .set(firebaseApp.TIMESTAMP)

      eventRef
        .child('left_at')
        .onDisconnect()
        .cancel()

      eventRef
        .child('data')
        .child(pageEventSubKey)
        .child('left_at')
        .set(firebaseApp.TIMESTAMP)

      eventRef
        .child('data')
        .child(pageEventSubKey)
        .child('left_at')
        .onDisconnect()
        .cancel()

        commit('setPageEventSid',null)
        commit('setPageEventKey',null)
        commit('setPageEventSubKey', null)


  },
  notifyByEmail({ getters }, { message, meta }) {

    const uid = getters.bindUID
    const sid = getters.bindSID

    if (getters.notifyByEmail &&
      meta.email
    )
      return axios.post('@@API/offline_message', {
        organization_id: getters.getOrgId,
        widget_id: getters.getWidgetId,
        visitor_id: uid,
        session_id: sid,
        email: meta.email,
        name: meta.name || meta.email,
        meta: {
          url: location.href,
          referrer: document.referrer,
          ...meta
        },
        message
      })
      .catch((e)=>{
        Raven.captureException(e)
      })

  }

}
